// extracted by mini-css-extract-plugin
export default {"food":"Food_food__u4V2P","food-appear":"Food_food-appear__w9JDu"};